module.exports = __webpack_public_path__ + "img/讲师审阅.b847701a.png";